import React from 'react';
import {Button, Flex} from '@priority-software/priority-style-react';
import styles from '.././styles.module.scss';
import cx from 'classnames';
import {AnnouncementItems} from '../consts/types';

type Props = {
    dotsCounter: number;
    curPageIndex: number;
    handleConfirmBtn: () => void;
    handleBackBtn: () => void;
    forwardBtnText: string;
    backwardsBtnText: string;
    announcement?: AnnouncementItems[];
};

export const Footer = (props: Props) => {
    const {
        dotsCounter,
        curPageIndex,
        handleConfirmBtn,
        handleBackBtn,
        forwardBtnText,
        backwardsBtnText,
        announcement
    } = props;

    const dots: string[] = [];
    if (!!dotsCounter) {
        for (let i = 0; i < dotsCounter; i++) {
            if (announcement && announcement[i]?.type !== 'Welcome') {
                dots.push(curPageIndex === i ? styles.fullDot : styles.emptyDot);
            }
        }
    }
    return (
        <Flex justifyContent="space-between" alignItems="center" componentClasses={styles.footer}>
            <Button onClick={handleBackBtn} skin="secondary" width="contentWidth" size="medium">
                {backwardsBtnText}
            </Button>

            <Flex justifyContent="center" alignItems="center">
                {!!dotsCounter &&
                    dots.map((dot, index) => {
                        return <span key={index} className={cx(styles.dot, dot)}></span>;
                    })}
            </Flex>
            <Button
                onClick={handleConfirmBtn}
                autoFocus={true}
                skin="primary"
                width="regularFixed"
                size="medium"
            >
                {forwardBtnText}
            </Button>
        </Flex>
    );
};
